import { render, staticRenderFns } from "./PropertyClientAddClientSearch.vue?vue&type=template&id=ea308636"
import script from "./PropertyClientAddClientSearch.vue?vue&type=script&lang=ts"
export * from "./PropertyClientAddClientSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports